import { render, staticRenderFns } from "./template2.vue?vue&type=template&id=7405c1f1&"
import script from "./template2.vue?vue&type=script&lang=js&"
export * from "./template2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports